export default {
  fontSizes: [8, 10, 12, 16, 23, 36],
  spaces: {
    small: '12px',
    medium: '24px',
    large: '36px',
  },
  padding: {
    small: '12px',
    medium: '24px',
    large: '36px',
  },
  graphSizes: {
    third: '33%',
    quarter: '25%',
    half: '50%',
    full: '90%',
    max: '100%',
  },
  colors: {
    textGrey: '#343434',
    textLightGrey: '#ADADAD',
    pink: '#fb1359',
    blue: '#5ca7ce',
    background: '#eee',
    darkGrey: '#616161',
    lightGrey: '#EBF4FF',
    offWhite: '#FDFDFD',
    lightPurple: '#9382FF',
    lighterPurple: '#E7E3FF',
    buttonGrey: '#242930',
    menu: '#242930',
    palette: ['#0B1823', '#122333', '#213E58', '#2B4F70', '#446D93', '#6994BB', '#B3CDE4', '#2D8BFF'],
    graphPalette: ['#323848', '#CBCED6', '#924B66', '#446D93', '#CEAFE6', '#A347FF', '#E7AFC4', '#F8377B', '#B3CDE4', '#2D8BFF'],
  },
  fontWeights: {
    thin: '100',
    normal: '400',
    bold: 'bold',
  },
  letterSpacings: {
    normal: 'normal',
    title: '0.5px',
    mega: '0.25em',
  },
  sizes: {
    topMenuHeight: '60px',
    sideMenuWidth: '54px',
    filterColWidth: '300px',
  },
  transition: {
    bezier: `cubic-bezier(0.19, 1, 0.22, 1)`,
  },
  shadow: {
    container: '0 2px 2px 0 rgba(0,0,0,0.02)',
  },
  cardWidths: {
    half: '50%',
    third: '33.33%',
    fourth: '25%',
  },
};
